






import Vue from "vue";
import Layout from "@/core/layout/_Layout.vue";

export default Vue.extend({
  name: "App",
  components: { Layout }
});
